"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../helpers/time");
var queryString_1 = require("../helpers/queryString");
var json_1 = require("../helpers/json");
var DrivesModel = /** @class */ (function () {
    function DrivesModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/drives",
            UPDATE: APPURL + "/api/v1/drives",
            CREATE: APPURL + "/api/v1/drives",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
        this.cacheDrive = this.cacheDrive.bind(this);
    }
    DrivesModel.prototype.extract = function (result) {
        return result.data;
    };
    DrivesModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    DrivesModel.prototype.cacheDrive = function (result) {
        var data = this.extract(result);
        var drive = (data.drive || data);
        if (typeof drive.address !== "undefined") {
            drive.address = (0, json_1.isJson)(drive.address)
                ? JSON.parse(drive.address)
                : drive.address;
            var pickup = drive.pickuplocation;
            //TODO: Make sure pickup.address is json, this might not be necessary
            pickup.address = (0, json_1.isJson)(pickup.address)
                ? JSON.parse(pickup.address)
                : pickup.address;
        }
        if (drive.locations) {
            drive.locations.forEach(function (location) {
                location.address = (0, json_1.isJson)(location.address)
                    ? JSON.parse(location.address)
                    : location.address;
            });
        }
        return data;
    };
    DrivesModel.prototype.getDriveByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheDrive);
    };
    DrivesModel.prototype.submitDriveSignature = function (drive_id, signature_data, signee_type) {
        return this.$http
            .post(this.URLS.FETCH + "/" + drive_id + "/signature", {
            signature_data: signature_data,
            signee_type: signee_type,
        })
            .then(this.cacheResults);
    };
    DrivesModel.prototype.claimDrive = function (data) {
        data["currentTime"] = (0, time_1.getUnixTimestamp)(new Date());
        return this.$http
            .post(this.URLS.FETCH + "/claim", data)
            .then(this.cacheResults);
    };
    DrivesModel.prototype.getDriveReportCard = function (id, student_id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/reportcard?student_id=" + student_id)
            .then(this.cacheResults);
    };
    DrivesModel.prototype.getDrives = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    DrivesModel.prototype.getDriveMeta = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/meta")
            .then(this.cacheResults);
    };
    DrivesModel.prototype.createDrive = function (drive) {
        return this.$http
            .post(this.URLS.CREATE, drive)
            .then(this.cacheResults);
    };
    DrivesModel.prototype.batchCreate = function (drives) {
        return this.$http
            .post(this.URLS.CREATE + "/batch", drives)
            .then(this.cacheResults);
    };
    DrivesModel.prototype.getDrivesRequiringAction = function (data) {
        return this.$http
            .get(this.URLS.FETCH + "/requiring-action?" + (0, queryString_1.toQueryString)(data))
            .then(function (response) {
            return response.data;
        });
    };
    DrivesModel.prototype.deleteDrive = function (id) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    DrivesModel.prototype.updateDrive = function (drive) {
        return this.$http
            .put(this.URLS.FETCH + "/" + drive.id, drive)
            .then(this.cacheDrive);
    };
    DrivesModel.prototype.cancelDriveSession = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/cancel/" + data.id, data)
            .then(this.cacheDrive);
    };
    DrivesModel.prototype.complete = function (data) {
        return this.$http
            .put(this.URLS.FETCH + "/" + data.id + "/complete", data)
            .then(this.cacheDrive);
    };
    DrivesModel.prototype.completeDrivingLessons = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/complete", data)
            .then(this.cacheDrive);
    };
    DrivesModel.prototype.filterDrives = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/filter", params)
            .then(this.cacheResults);
    };
    DrivesModel.prototype.search = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/search", params)
            .then(this.cacheResults);
    };
    return DrivesModel;
}());
DrivesModel.$inject = ["$http", "APPURL"];
exports.default = DrivesModel;
